import { cn } from "@u/cn";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

interface ViewAllLinkProps {
  /** Link target. Omit (and pass onClick) to render a button instead. */
  to?: string;
  label: string;
  /** Button mode — used when the action is a scroll/handler, not navigation. */
  onClick?: () => void;
  className?: string;
}

/**
 * Mono "ver todos ›" link with a ChevronRight that nudges right on hover — the
 * dashboard idiom for a card/section footer that leads to the full collection.
 * Renders an in-app `<Link>` for `to`, or a `<button>` when only `onClick` is
 * given. (Marketing surfaces use `BracketLink` — the `[ ]` idiom — instead.)
 */
export function ViewAllLink({ to, label, onClick, className }: ViewAllLinkProps) {
  const classes = cn(
    "group inline-flex items-center gap-1 text-xs font-mono uppercase tracking-widest",
    // nowrap: en mobile el label envolvía en dos líneas y chocaba contra lo que
    // tuviera a la izquierda (header del portfolio feed).
    "whitespace-nowrap shrink-0",
    "text-muted-foreground hover:text-primary dark:hover:text-white transition-colors duration-200",
    className,
  );
  const inner = (
    <>
      {label}
      <ChevronRight
        size={14}
        className="transition-transform duration-200 group-hover:translate-x-0.5"
      />
    </>
  );

  if (!to) {
    return (
      <button type="button" onClick={onClick} className={classes}>
        {inner}
      </button>
    );
  }
  return (
    <Link to={to} onClick={onClick} className={classes}>
      {inner}
    </Link>
  );
}
